// Short game-specific reveal sound when a result number lands (Web Audio, no files). Respects the app mute + win-chime quiet hours.
import { isMuted } from "./sound";
import { inQuietHours } from "./winChime";

const KIND = { kerala: "drum", dear: "drum", singam: "drum", bramah: "bell", lakshmi: "bell", royal: "bell", special: "bell", golden: "coin", "golden-raja": "coin", jackpot: "coin", lucky: "coin", 777: "coin", sikkim: "chime", mangatha: "chime", raja: "gong", goa: "chime", morning: "bell", night: "gong" };

const env = (ctx, node, t, peak, dur) => { const g = ctx.createGain(); g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(peak, t + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t + dur); node.connect(g).connect(ctx.destination); return g; };
const osc = (ctx, type, f, t, dur, peak = 0.25, slide) => { const o = ctx.createOscillator(); o.type = type; o.frequency.setValueAtTime(f, t); if (slide) o.frequency.exponentialRampToValueAtTime(slide, t + dur); env(ctx, o, t, peak, dur); o.start(t); o.stop(t + dur + 0.05); };

const PATTERNS = {
  drum: (c, t) => { [0, 0.16, 0.32, 0.6].forEach((d, i) => osc(c, "sine", i === 3 ? 70 : 140, t + d, 0.3, 0.6, 45)); },
  bell: (c, t) => { [[880, 0], [1318, 0.05], [1760, 0.1]].forEach(([f, d]) => osc(c, "sine", f, t + d, 1.4, 0.18)); osc(c, "triangle", 440, t, 1.6, 0.12); },
  coin: (c, t) => { [[1568, 0], [2093, 0.08], [2637, 0.16], [3136, 0.26]].forEach(([f, d]) => osc(c, "square", f, t + d, 0.18, 0.06)); osc(c, "sine", 1046, t + 0.3, 0.9, 0.15); },
  chime: (c, t) => { [523, 659, 784, 1046, 1318].forEach((f, i) => osc(c, "triangle", f, t + i * 0.09, 0.6, 0.16)); },
  gong: (c, t) => { osc(c, "sine", 196, t, 2.2, 0.35, 150); osc(c, "triangle", 392, t, 1.6, 0.12); osc(c, "sine", 587, t + 0.02, 1.2, 0.08); },
};

export const SOUNDS = [["drum", "Drum 🥁"], ["bell", "Bell 🔔"], ["coin", "Coins 🪙"], ["chime", "Chime ✨"], ["gong", "Gong 🪘"]];
export const soundKindFor = (theme) => theme?.sound || KIND[theme?.key] || (String(theme?.key).startsWith("auto") ? "chime" : "bell");

export function playRevealSound(themeKey, kind) {
  if (isMuted() || inQuietHours()) return;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    kind = kind || KIND[themeKey] || (String(themeKey).startsWith("auto") ? "chime" : "bell");
    PATTERNS[kind](ctx, ctx.currentTime + 0.02);
    try { navigator.vibrate?.(kind === "drum" ? [80, 40, 80, 40, 160] : [60, 30, 120]); } catch {}
    setTimeout(() => ctx.close().catch(() => {}), 3000);
  } catch {}
}
